<template>
  <div class="myDepartments">
    <div class="top-background">
      <img
        src="@/assets/img/home/home-top.png"
        alt="背景"
        class="background-img"
      />
      <userShopInfo></userShopInfo>
    </div>
    <div class="content">
      <div
        v-for="item in departmentList"
        :key="item.department_uuid"
        class="department-item"
        @click="goToDepartment(item)"
      >
        <div class="department-name">
          {{ item.department.name }} - {{ item.position.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import userShopInfo from "@/components/usershopinfo.vue";
import authApi from "@/utils/api/auth";
import { useRouter } from "vue-router";
const router = useRouter();

const departmentList = ref([]);
onMounted(() => {
  authApi.myDepartments().then((res) => {
    departmentList.value = res.data;
  });
});

const goToDepartment = (item) => {
  const departmentdata = {
    department_uuid: item.department_uuid,
    department_name: item.department.name,
    department_type: item.department.type,
    position_name: item.position.name,
    position_uuid: item.position.uuid,
    shop_name: item.department.shop?.name,
    shop_address: item.department.shop?.address,
  };
  localStorage.setItem("departmentdata", JSON.stringify(departmentdata));
  //返回上一页
  router.back();
};
</script>

<style lang="less" scoped>
.myDepartments {
  min-height: 100vh;
  padding-bottom: 70px;
  position: relative;
  font-family: "PingFang SC-Heavy";

  .top-background {
    position: relative;
    overflow: hidden;

    .background-img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      object-fit: cover;
    }
  }

  .content {
    padding: 15px;
    box-sizing: border-box;

    .department-item {
      background-color: #fff;
      padding: 15px;
      box-sizing: border-box;
      border-radius: 10px;
      margin-bottom: 15px;

      .department-name {
        font-size: 15px;
        line-height: 24px;
        color: #333;
        font-weight: 500;
      }
    }
  }
}
</style>
